import { z } from '../zod';
import {
  CursorPaginationValidationBaseSchema,
  withCursorPaginationValidation,
} from '../shared/cursorPagination';
import { PageStatusEnumValidationSchema } from './enum';

export function createPageListQueryValidationSchema(searchDescription: string) {
  return withCursorPaginationValidation(
    CursorPaginationValidationBaseSchema.extend({
      status: PageStatusEnumValidationSchema.optional().meta({
        description:
          'Filter by publication status: `published`, `draft` or `archived`. Only one status per call. Without it, published and draft pages are returned and archived pages are excluded, so pass `archived` explicitly to see archived pages.',
      }),
      search: z.string().optional().meta({
        description: searchDescription,
      }),
      testmode: z.boolean().optional().meta({
        description:
          'Set to true to return only pages in test mode, or false for only pages not in test mode.',
      }),
    }),
  );
}
